
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#CCE8FF","d":"M21 6h8v8h-2v4h-2l2 13h2l1 4h-9z"}}),_c('path',{attrs:{"stroke":"#2196F3","stroke-linejoin":"round","stroke-width":"2","d":"M13 14V6h16v8zM13 31h16l1 4H12z"}}),_c('path',{attrs:{"stroke":"#2196F3","stroke-width":"2","d":"M15 31l2-13h8l2 13z"}}),_c('path',{attrs:{"stroke":"#2196F3","stroke-linejoin":"round","stroke-width":"2","d":"M15 14v4h12v-4z"}}),_c('path',{attrs:{"stroke":"#2196F3","stroke-width":"2","d":"M18 10V7m6 3V7"}})])])
          )
        }
      }
    